import React from 'react';
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
const menuSocial = [
    {
        name: 'Facebook',
        icon: <FaFacebookF />,
        url: 'https://www.facebook.com/ROOTSTOKEN/',
    },
    {
        name: 'Instagram',
        icon: <FaInstagram />,
        url: 'https://www.instagram.com/rootstoken',
    },
    // {
    //     icon: <FaTiktok />,
    //     url: 'https://www.tiktok.com/@rootstoken0?_t=ZM-8tJT4lNOebW&_r=1',
    // },
    {
        name: 'Whatsapp',
        icon: <FaWhatsapp />,
        url: 'https://wa.me/5215629933625',
    },
];
export default function SocialComponent() {
    return (
        <div className="nv__social">
            <ul>
                {menuSocial.map((item) => {
                    return (
                        <li key={item.name}>
                            <Link to={item.url} target="_blank">
                                {' '}
                                {item.icon}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
